import React from 'react';
import { motion } from 'framer-motion';
import { Check, AlertTriangle, Clock, ListOrdered, Leaf } from 'lucide-react';
export function MechanismSection() {
  const features = [{
    icon: <ListOrdered className="h-6 w-6 text-terracotta" data-id="element-193" />,
    title: 'Organizado por síntoma',
    desc: 'No pierdas tiempo buscando. Encuentra lo que necesitas al instante.'
  }, {
    icon: <Check className="h-6 w-6 text-terracotta" data-id="element-194" />,
    title: 'Pasos ordenados',
    desc: 'Sabe exactamente qué hacer primero, segundo y tercero.'
  }, {
    icon: <AlertTriangle className="h-6 w-6 text-terracotta" data-id="element-195" />,
    title: 'Señales de alerta claras',
    desc: 'Identifica cuándo puedes actuar en casa y cuándo ir al médico.'
  }, {
    icon: <Leaf className="h-6 w-6 text-terracotta" data-id="element-196" />,
    title: 'Ingredientes simples',
    desc: 'Usa lo que ya tienes en tu cocina o despensa.'
  }, {
    icon: <Clock className="h-6 w-6 text-terracotta" data-id="element-197" />,
    title: 'Disponible en 3 segundos',
    desc: 'Acceso inmediato desde tu celular, incluso sin internet.'
  }];
  return <section className="py-24 bg-white" data-id="element-198">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-199">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-200">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-forest mb-6 font-serif" data-id="element-201">
            Por qué los remedios caseros solos no funcionan — y qué cambia todo
          </motion.h2>
          <p className="text-lg text-forest/70" data-id="element-202">
            El error más común que cometen las mamás no es elegir el remedio
            equivocado.{' '}
            <span className="font-bold text-forest" data-id="element-203">Es no tener un orden.</span>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-204">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-6 text-lg text-forest/80" data-id="element-205">
            <p data-id="element-206">
              Un remedio natural puede ser extraordinariamente efectivo. Pero si
              no sabes cuándo usarlo, cómo combinarlo, y qué señal te dice que
              es momento de ir al médico — estás adivinando en un momento donde
              no puedes darse el lujo de adivinar.
            </p>
            <p data-id="element-207">Lo que funciona no es tener más información.</p>
            <div className="p-6 bg-cream rounded-xl border-l-4 border-sage" data-id="element-208">
              <p className="font-bold text-forest text-xl" data-id="element-209">
                Lo que funciona es tener el sistema correcto: el Protocolo de
                Primera Respuesta Natural.
              </p>
            </div>
            <p data-id="element-210">
              Eso es lo que hace PequeSalud Natural diferente a cualquier cosa
              que hayas leído antes.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-forest text-cream p-8 rounded-3xl shadow-xl relative overflow-hidden" data-id="element-211">
            <div className="absolute top-0 right-0 w-64 h-64 bg-sage/20 rounded-full blur-3xl -mr-16 -mt-16 pointer-events-none" data-id="element-212"></div>

            <h3 className="text-2xl font-bold mb-8 font-serif text-terracotta-light" data-id="element-213">
              El Sistema Incluye:
            </h3>

            <ul className="space-y-6 relative z-10" data-id="element-214">
              {features.map((feature, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-215">
                  <div className="bg-cream/10 p-2 rounded-lg mt-1" data-id="element-216">
                    {feature.icon}
                  </div>
                  <div data-id="element-217">
                    <h4 className="font-bold text-lg" data-id="element-218">{feature.title}</h4>
                    <p className="text-cream/70 text-sm" data-id="element-219">{feature.desc}</p>
                  </div>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}